(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Adds 'Back to top' functionality to an element with the ID 'back-to-top'
 * @example 
 * 1. Create a link-wrapper with ID 'back-to-top'
 * 2. Add an icon inside the link-wrapper such as an arrow
 * 3. Set position fixed: bottom right
 * 4. Set opacity to 0
 */
var BackToTop =
/*#__PURE__*/
function () {
  function BackToTop() {
    _classCallCheck(this, BackToTop);

    this.$backToTop = $('#back-to-top');
    this.toggleDistance = 50;

    if (this.$backToTop.length > 0) {
      this.init();
    }
  }

  _createClass(BackToTop, [{
    key: "init",
    value: function init() {
      var _this = this;

      window.onscroll = function () {
        return _this.scrollFunction();
      };

      this.$backToTop.on('click', function () {
        return _this.scrollToTop();
      });
    }
  }, {
    key: "scrollFunction",
    value: function scrollFunction() {
      if (document.body.scrollTop > this.toggleDistance || document.documentElement.scrollTop > this.toggleDistance) {
        this.$backToTop.css({
          'opacity': '1',
          'cursor': 'pointer',
          'pointer-events': 'all'
        });
      } else {
        this.$backToTop.css({
          'opacity': '0',
          'cursor': 'default',
          'pointer-events': 'none'
        });
      }
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      window.scrollTo(0, 0);
    }
  }]);

  return BackToTop;
}();

var _default = BackToTop;
exports.default = _default;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Sample module for adding new functionality or website components
 * @example 
 * #Add instructions here
 */
var LawyerSlider =
/*#__PURE__*/
function () {
  function LawyerSlider() {
    _classCallCheck(this, LawyerSlider);

    // Check if exists and initialize
    this.$slider = $('#home-lawyer-description-repeater');
    this.oxyActive = $('#ct-controller-ui');

    if (this.$slider.length > 0 && this.oxyActive.length === 0) {
      this.init();
    }
  }

  _createClass(LawyerSlider, [{
    key: "init",
    value: function init() {
      // Initialize component(s)
      $('#home-lawyer-description-repeater').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        speed: 1500,
        cssEase: 'ease-in-out',
        asNavFor: '#home-lawyer-image-repeater',
        dots: true,
        infinite: false,
        nextArrow: '<i class="lawyer-next-arrow">></i>',
        prevArrow: '<i class="lawyer-prev-arrow">˂</i>'
      });
      $('#home-lawyer-image-repeater').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        speed: 1500,
        cssEase: 'ease-in-out',
        asNavFor: '#home-lawyer-description-repeater',
        arrows: false,
        infinite: false
      });
    }
  }]);

  return LawyerSlider;
}();

var _default = LawyerSlider;
exports.default = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Used to lazy load videos. Videos must use a fixed HTML construct
 * Note: for this to work, HTML comments must NOT be stripped with performance plugin
 * @example 
 *  <div class="js-lazy-load-video" style="background-image: url('poster.jpg');">
 *   <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/q6EoRBvdVPQ?autoplay=1&amp;rel=0&amp;controls=0" frameborder="0" allowfullscreen></iframe>-->
 *  </div>
 */
var LazyLoadVideos =
/*#__PURE__*/
function () {
  function LazyLoadVideos() {
    _classCallCheck(this, LazyLoadVideos);

    // Check if exists and initialize
    this.$lazyLoadVideos = $('.js-lazy-load-video');
    this.$lazyLoadModalButton = $('.js-open-lazy-modal-video');

    if (this.$lazyLoadVideos.length > 0) {
      // console.log( 'initializing video lazy loading' );
      this.init();
    }

    if (this.$lazyLoadModalButton.length > 0) {
      // console.log( 'initializing lazy loaded modal video' );
      this.initLazyModalVideo();
    }
  }

  _createClass(LazyLoadVideos, [{
    key: "init",
    value: function init() {
      var _this = this;

      // Initialize component(s)       
      this.$lazyLoadVideos.on("click", function (e) {
        return _this.handleVideoClick(e);
      });
    }
  }, {
    key: "initLazyModalVideo",
    value: function initLazyModalVideo() {
      var _this2 = this;

      var targetModalId = this.$lazyLoadModalButton.attr('data-modal-target');
      var $targetModal = $('#' + targetModalId);
      var $modalLazyVideo = $targetModal.find('.js-lazy-load-modal-video');
      var $modalBackdrop = $targetModal.parents('.oxy-modal-backdrop');
      var $modalCloseButton = $targetModal.find('.js-modal-close-btn');

      if ($modalLazyVideo.length > 0) {
        this.$lazyLoadModalButton.on('click.openlazymodal', function (e) {
          _this2.handleLazyModalVideoButtonClick(e, $modalLazyVideo);
        });
      } else {
        console.log('Error: found lazy load button, but couldn\'t find target video with .js-lazy-load-modal-video class');
      }

      $modalBackdrop.on('click', function () {
        _this2.stopVideo($modalLazyVideo);
      }); //$modalCloseButton.on( 'click' , () => { this.stopVideo( $modalLazyVideo ) } );
    }
  }, {
    key: "stopVideo",
    value: function stopVideo($el) {
      // console.log( 'stopping video' );
      //$el.find( 'iframe' ).get(0).contentWindow.postMessage('{"event":"command","func":"stopVideo","args":[]}', '*');
      $el.find('iframe').removeAttr('src', "");
    }
  }, {
    key: "handleVideoClick",
    value: function handleVideoClick(e) {
      // console.log( 'lazy loaded video clicked' );
      var $elm = $(e.currentTarget);
      this.loadVideo($elm);
    }
  }, {
    key: "handleLazyModalVideoButtonClick",
    value: function handleLazyModalVideoButtonClick(e, $modalVideo) {
      // console.log( 'lazy loaded modal video initializing' );
      // console.log( $modalVideo.find('iframe') );
      if ($('body').hasClass('lazy-modal-initialized')) {
        $modalVideo.find('iframe').attr('src', this.modalVideoSrc);
      } else {
        this.loadVideo($modalVideo);
        $('body').addClass('lazy-modal-initialized');
        this.modalVideoSrc = $modalVideo.find('iframe').attr('src');
      }
    }
  }, {
    key: "loadVideo",
    value: function loadVideo($element) {
      // console.log( 'loading element: ' + $element.contents() );
      var $elm = $element,
          conts = $elm.contents(),
          le = conts.length,
          ifr = null;

      for (var i = 0; i < le; i++) {
        if (conts[i].nodeType == 8) ifr = conts[i].textContent;
      }

      $elm.addClass("player").html(ifr);
      $elm.off("click");
    }
  }]);

  return LazyLoadVideos;
}();

var _default = LazyLoadVideos;
exports.default = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Sample module for adding new functionality or website components
 * @example 
 * #Add instructions here
 */
var MobileReviewsSlider =
/*#__PURE__*/
function () {
  function MobileReviewsSlider() {
    _classCallCheck(this, MobileReviewsSlider);

    // Check if exists and initialize
    this.$sidebarGoogleReviews = $('.wp-google-reviews');
    this.isMobileViewport = false;
    this.isSlickSlider = $.fn.slick;

    if (this.$sidebarGoogleReviews.length > 0 && this.isMobileViewport && this.isSlickSlider) {
      this.init();
    }
  }

  _createClass(MobileReviewsSlider, [{
    key: "init",
    value: function init() {
      // Initialize component(s)
      this.$sidebarGoogleReviews.slick({});
    }
  }]);

  return MobileReviewsSlider;
}();

var _default = MobileReviewsSlider;
exports.default = _default;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Fixes oxygen modals so that modals can be scrolled if the screen height
 * can't accomodate the contents of the modal
 * @example 
 * # Just add the class 'js-watch-oxy-modal' to any modals that you want the
 * # Oxy Modal Watcher to manage.
 */
var OxyModalWatcher =
/*#__PURE__*/
function () {
  function OxyModalWatcher() {
    _classCallCheck(this, OxyModalWatcher);

    this.$modals = $('.ct-modal.js-watch-oxy-modal');

    if (this.$modals.length > 0) {
      console.log('Initializing modal watcher ...');
      window.myModals = this.$modals;
      this.init();
    }
  }

  _createClass(OxyModalWatcher, [{
    key: "init",
    value: function init() {
      var _this = this;

      $('.oxygen-builder-body .oxy-modal-backdrop').css('height', 'auto');
      if ($('html').attr('ng-app') == 'CTFrontendBuilder') return;
      this.$modalBGs = this.$modals.parent('.oxy-modal-backdrop');
      this.fixflex();
      $(window).resize(function () {
        _this.fixflex();
      });
    } // end init()

  }, {
    key: "scrollbarWidth",
    value: function scrollbarWidth() {
      var block = $('<div>').css({
        'height': '50px',
        'width': '50px'
      }),
          indicator = $('<div>').css({
        'height': '200px'
      });
      $('body').append(block.append(indicator));
      var w1 = $('div', block).innerWidth();
      block.css('overflow-y', 'scroll');
      var w2 = $('div', block).innerWidth();
      $(block).remove();
      return w1 - w2;
    } // end scrollbarWidth()

  }, {
    key: "fixflex",
    value: function fixflex() {
      var _this2 = this;

      $.each(this.$modalBGs, function (k, bg) {
        var backpos = $(bg).css('align-items'),
            screenh = $(window).height(),
            barh = $('#wpadminbar').height();
        $(bg).css({
          'height': 'calc(100% - ' + barh + 'px)',
          'top': +barh + 'px'
        });
        var backsize = $(bg).height();

        if (backsize > screenh) {
          if ($(bg).hasClass('right')) {
            $(bg).css('align-items', 'flex-end');
            $(bg).css('justify-content', 'flex-start');
          } else if ($(bg).hasClass('left')) {
            $(bg).css('justify-content', 'flex-start');
          } else {
            $(bg).css('align-items', 'flex-start');
          }
        } else {
          if ($(bg).hasClass('right')) {
            $(bg).css('justify-content', 'center');
          } else if ($(bg).hasClass('left')) {
            $(bg).css('justify-content', 'center');
          } else {
            $(bg).css('align-items', backpos);
          }
        }

        var cssObserver = new MutationObserver(function (mutations) {
          var bg = mutations[0].target;

          if ($(bg).css('display') == 'flex') {
            $('body').css({
              'overflow-y': 'hidden',
              'height': '100%',
              'position': 'relative',
              'margin-right': _this2.scrollbarWidth() + 'px'
            });
            $(bg).css('overflow-y', 'auto');

            if ($(bg).find('.ct-modal[data-aos]').attr('data-aos').indexOf('left')) {
              $(bg).css('overflow-x', 'hidden');
            }
          } else if ($(bg).css('display') == 'none') {
            $('.oxy-modal-backdrop').removeClass("live");
            setTimeout(function () {
              $('body').css({
                'overflow-y': 'auto',
                'margin-right': '0'
              });
            }, 300);
          }
        });
        cssObserver.observe(bg, {
          attributes: true,
          attributeFilter: ['style']
        });
      }); // end $.each()
    } // end fixflex()

  }]);

  return OxyModalWatcher;
}();

var _default = OxyModalWatcher;
exports.default = _default;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = plugin;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Generate a jQuery plugin
 * @param pluginName [string] Plugin name
 * @param className [object] Class of the plugin
 * @param shortHand [bool] Generate a shorthand as $.pluginName
 *
 * @example
 * import plugin from 'plugin';
 *
 * class MyPlugin {
 *     constructor(element, options) {
 *         // ...
 *     }
 * }
 *
 * MyPlugin.DEFAULTS = {};
 *
 * plugin('myPlugin', MyPlugin');
 */
function plugin(pluginName, className) {
  var shortHand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var dataName = "__".concat(pluginName);
  var old = $.fn[pluginName];

  $.fn[pluginName] = function (option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data(dataName);
      var options = $.extend({}, className.DEFAULTS, $this.data(), _typeof(option) === 'object' && option);

      if (!data) {
        $this.data(dataName, data = new className(this, options));
      }

      if (typeof option === 'string') {
        data[option]();
      }
    });
  }; // - Short hand


  if (shortHand) {
    $[pluginName] = function (options) {
      return $({})[pluginName](options);
    };
  } // - No conflict


  $.fn[pluginName].noConflict = function () {
    return $.fn[pluginName] = old;
  };
}

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Sample module for adding new functionality or website components
 * @example 
 * #Add instructions here
 */
var PracticeAreasSidebarMenu =
/*#__PURE__*/
function () {
  function PracticeAreasSidebarMenu() {
    _classCallCheck(this, PracticeAreasSidebarMenu);

    // Check if exists and initialize
    this.$menu = $('#menu-practice-areas');

    if (this.$menu.length > 0) {
      this.init();
    }
  }

  _createClass(PracticeAreasSidebarMenu, [{
    key: "init",
    value: function init() {
      // Initialize component(s)
      this.$firstMenuItem = this.$menu.find('li:first-child').find('.sub-menu-toggle').click();
    }
  }]);

  return PracticeAreasSidebarMenu;
}();

var _default = PracticeAreasSidebarMenu;
exports.default = _default;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Script for Responsive Tabs component
 * @example 
 * http://www.entheosweb.com/tutorials/css/tabs.asp
 */
var ResponsiveTabs =
/*#__PURE__*/
function () {
  function ResponsiveTabs(element) {
    _classCallCheck(this, ResponsiveTabs);

    if ($(element).length > 0) {
      this.init(element);
    }
  }

  _createClass(ResponsiveTabs, [{
    key: "init",
    value: function init(element) {
      var _this = this;

      this.$tabsObj = $(element); // Initialize all tab containers and elements to reference

      this.$tabsContainer = this.$tabsObj.find(".tab_container");
      this.$tabs = this.$tabsObj.find('.tabs');
      this.$tabContent = this.$tabsObj.find(".tab_content"); // Hide all tab contents except the first one

      this.$tabsContainer.find('.tab_content').hide();
      this.$tabsContainer.find('.tab_content:first').show();
      this.$drawerToggleIcons = $('.tab_container .oxy-expand-collapse-icon'); // Set the height of the minimum height of the tab container (contains tab contents)
      // to the height of the tabs
      // this.$tabsContainer.css("min-height", () => { 
      //     return this.$tabs.outerHeight() + 50;
      // });

      /* Bind event handler for tabs clicks */

      this.$tabs.find('li').click(function (e) {
        return _this.handleTabClick(e);
      });
      /* Bind event handler for tabs clicks if in drawer mode */

      this.$tabsContainer.find(".tab_drawer_heading").click(function (e) {
        return _this.handleDrawerTabClick(e);
      });
      /* Uncomment to add extra class "tab_last" to last tab */
      //this.$tabs.find('li').last().addClass("tab_last");
    }
  }, {
    key: "handleTabClick",
    value: function handleTabClick(e) {
      // Hide all tabs contents
      this.$tabContent.hide(); // Get the "rel" value (ID of the contents to display)

      var activeTabID = $(e.currentTarget).attr("rel"); // Fade in the contents for the active tab. Store reference to active tab just in case

      this.$activeTab = this.$tabsContainer.find("#" + activeTabID).fadeIn(); // Remove active class from all tabs

      this.$tabs.find("li").removeClass("active"); //Add active class to tab item that was clicked

      $(e.currentTarget).addClass("active"); // Remove d_active class from drawer heading

      this.$tabsContainer.find(".tab_drawer_heading").removeClass("d_active"); // Add active class to respective drawer heading for the tab that was clicked 

      this.$tabsContainer.find(".tab_drawer_heading[rel^='" + activeTabID + "']").addClass("d_active"); // this.$tabs.css('min-height', 0);
      // // this.$tabsContainer.css("min-height", () => { 
      // //     return this.$tabs.outerHeight() + 50;
      // // });
    }
  }, {
    key: "handleDrawerTabClick",
    value: function handleDrawerTabClick(e) {
      // Hide all tabs contents
      this.$tabContent.hide();
      var $clickTarget = $(e.currentTarget);
      console.log(e); // Remove d_active class from drawer heading

      this.$tabsContainer.find(".tab_drawer_heading").removeClass("d_active"); // Get the "rel" value (ID of the contents to display)

      var d_activeTabID = $(e.currentTarget).attr("rel"); // Fade in the contents for the active tab. Store reference to active tab just in case

      this.$tabsContainer.find("#" + d_activeTabID).fadeIn(); // this.$tabsContainer.find("#"+d_activeTabID).show();
      // Add active class to respective drawer heading for the tab that was clicked 

      $clickTarget.addClass("d_active");
      this.$drawerToggleIcons.addClass('oxy-eci-collapsed');
      $clickTarget.find('.oxy-expand-collapse-icon').removeClass('oxy-eci-collapsed'); // Remove active class from all tabs

      this.$tabs.find("li").removeClass("active"); //Add active class to tab item that was clicked

      this.$tabs.find("li[rel^='" + d_activeTabID + "']").addClass("active"); // this.$tabs.css('min-height', 0);
      // this.$tabs.css("min-height", () => { 
      //     return this.$tabsContainer.outerHeight() + 50;
      // });
    }
  }]);

  return ResponsiveTabs;
}();

var _default = ResponsiveTabs;
exports.default = _default;

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Sample module for adding new functionality or website components
 * @example 
 * #Add instructions here
 */
var ReviewSlider =
/*#__PURE__*/
function () {
  function ReviewSlider() {
    _classCallCheck(this, ReviewSlider);

    // Check if exists and initialize
    this.$slider = $('.js-review-slider');
    this.oxyActive = $('#ct-controller-ui');
    console.log(this.oxyActive.length);

    if (this.$slider.length > 0 && this.oxyActive.length === 0) {
      this.init();
    }
  }

  _createClass(ReviewSlider, [{
    key: "init",
    value: function init() {
      // Initialize component(s)
      if (this.$slider.hasClass('js-single-slide-slider')) {
        this.$slider.slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          nextArrow: '<div class="review-left-arrow"><svg><use xlink:href="#FontAwesomeicon-chevron-right"></use></svg></div>',
          prevArrow: '<div class="review-right-arrow"><svg><use xlink:href="#FontAwesomeicon-chevron-left"></use></svg></div>',
          adaptiveHeight: true
        });
      } else {
        this.$slider.slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          nextArrow: '<div class="review-left-arrow"><svg><use xlink:href="#FontAwesomeicon-chevron-right"></use></svg></div>',
          prevArrow: '<div class="review-right-arrow"><svg><use xlink:href="#FontAwesomeicon-chevron-left"></use></svg></div>',
          mobileFirst: true,
          responsive: [{
            breakpoint: 1024,
            settings: {
              arrows: true,
              slidesToShow: 2
            }
          }, {
            breakpoint: 480,
            settings: {
              arrows: true,
              slidesToShow: 1
            }
          }]
        });
      }
    }
  }]);

  return ReviewSlider;
}();

var _default = ReviewSlider;
exports.default = _default;

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Opens social sharing links in a small popup window
 * @example 
 * 1. Add the class .js-social-share-popup to social share links
 */
var SocialSharePopups =
/*#__PURE__*/
function () {
  function SocialSharePopups() {
    _classCallCheck(this, SocialSharePopups);

    // Check if exists and initialize
    this.$socialShareLinks = $('.js-social-share-popup');
    this.viewportMinSize = 768;

    if (this.$socialShareLinks.length > 0 && $(window).width() > this.viewportMinSize) {
      this.init();
    }
  }

  _createClass(SocialSharePopups, [{
    key: "init",
    value: function init() {
      var _this = this;

      // Initialize component(s)
      console.log('social popups initialized');
      this.$socialShareLinks.on('click', function (e) {
        return _this.handleSocialShareLinkClick(e);
      });
    }
  }, {
    key: "handleSocialShareLinkClick",
    value: function handleSocialShareLinkClick(e) {
      e.preventDefault();
      var targetUrl = $(e.currentTarget).attr('href');
      var newWin = window.open(targetUrl, 'sharewindow', 'width=600,height=400');
    }
  }]);

  return SocialSharePopups;
}();

var _default = SocialSharePopups;
exports.default = _default;

},{}],11:[function(require,module,exports){
"use strict";

var _plugin = _interopRequireDefault(require("./modules/plugin"));

var _backToTop = _interopRequireDefault(require("./modules/back-to-top"));

var _socialSharePopups = _interopRequireDefault(require("./modules/social-share-popups"));

var _responsiveTabs = _interopRequireDefault(require("./modules/responsive-tabs"));

var _reviewSlider = _interopRequireDefault(require("./modules/review-slider"));

var _fancyLawyerSlider = _interopRequireDefault(require("./modules/fancy-lawyer-slider"));

var _mobileReviewsSlider = _interopRequireDefault(require("./modules/mobile-reviews-slider"));

var _lazyLoadVideos = _interopRequireDefault(require("./modules/lazy-load-videos"));

var _practiceSidebarMenu = _interopRequireDefault(require("./modules/practice-sidebar-menu"));

var _oxyModalWatcher = _interopRequireDefault(require("./modules/oxy-modal-watcher"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */
// import $ from 'jquery';
window.$ = jQuery;
$(document).ready(function () {
  $('html').addClass('js-on-load');
  var backToTop = new _backToTop.default();
  var socialSharePopups = new _socialSharePopups.default();
  var mobileReviewsSlider = new _mobileReviewsSlider.default();
  var lazyLoadVideos = new _lazyLoadVideos.default();
  var practiceAreasSidebarMenu = new _practiceSidebarMenu.default();
  var oxyModalWatcher = new _oxyModalWatcher.default();
  (0, _plugin.default)('ResponsiveTabs', _responsiveTabs.default);
  var $responsiveTabs = $('.responsive-tabs-component');

  if ($responsiveTabs.length > 0) {
    $responsiveTabs.ResponsiveTabs();
  }

  var reviewSlider = new _reviewSlider.default();
  var lawyerSlider = new _fancyLawyerSlider.default();
}); // $(window).bind( 'load', function(){
//         const dynamicCode = new DynamicCode();
// });

},{"./modules/back-to-top":1,"./modules/fancy-lawyer-slider":2,"./modules/lazy-load-videos":3,"./modules/mobile-reviews-slider":4,"./modules/oxy-modal-watcher":5,"./modules/plugin":6,"./modules/practice-sidebar-menu":7,"./modules/responsive-tabs":8,"./modules/review-slider":9,"./modules/social-share-popups":10}]},{},[11]);
